import type { CartJSONData } from '../../models/Cart'
import { manifest } from './manifest-store'
import { nanoquery } from '@nanostores/query'
import type { AddItemToCartPayload } from '../../models/Cart'
import { agentStore } from './stores'

export const [createCartFetcherStore, createCartMutator] = nanoquery({
  fetcher: async (..._keys: (string | number | boolean)[]): Promise<CartJSONData | undefined> => {
    const $agentStore = agentStore.get()
    const $agent = $agentStore.data

    // TODO: agent mode don't retrieve cart info
    if ($agent) {
      return
    }

    const $manifest = manifest.get()
    const { headerCartTotalsClient, getCartItemQuantity } = await import(/* @vite-ignore */ $manifest.mfe_grayskull.client.url)

    const totalRes = await headerCartTotalsClient()
    document.dispatchEvent(
      new CustomEvent('SHOPNEXT_EVENT_SOURCE', {
        detail: {
          eventName: 'CART_QUANTITY_FETCHED',
          version: '1',
          createdAt: new Date().toJSON(),
          data: {
            quantity: getCartItemQuantity(totalRes),
          },
        },
      })
    )
    return totalRes
  },
})

export const mergeCart = createCartMutator(async ({ revalidate }) => {
  const $manifest = manifest.get()
  const { mergeCartClient } = await import(/* @vite-ignore */ $manifest.mfe_grayskull.client.url)
  await mergeCartClient()

  revalidate('cart')

  return
})

export const addToCart = createCartMutator<AddItemToCartPayload>(async ({ data, revalidate }) => {
  const $manifest = manifest.get()
  const { addToCartClient } = await import(/* @vite-ignore */ $manifest.mfe_grayskull.client.url)

  const res = await addToCartClient(data)

  revalidate('cart')

  return Promise.resolve(res)
})
